import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';

const InventorySection = ({ cin7Data, shopifyInventory }) => {
  const cin7Config = [
    { key: 'onHand', label: 'On Hand', color: '#1976d2', bgColor: '#e3f2fd' },
    { key: 'allocated', label: 'Allocated', color: '#f57c00', bgColor: '#fff8e1' },
    { key: 'available', label: 'Available', color: '#388e3c', bgColor: '#e8f5e8' },
    { key: 'onOrder', label: 'On Order', color: '#424242', bgColor: '#f5f5f5' }
  ];

  const shopifyConfig = [
    { key: 'onHand', label: 'On Hand', color: '#1976d2', bgColor: '#e3f2fd', dataSource: shopifyInventory },
    { key: 'committed', label: 'Committed', color: '#f57c00', bgColor: '#fff8e1', dataSource: shopifyInventory },
    { key: 'available', label: 'Available', color: '#388e3c', bgColor: '#e8f5e8', dataSource: shopifyInventory },
    { key: 'unavailable', label: 'Unavailable', color: '#d32f2f', bgColor: '#ffebee', dataSource: shopifyInventory }
  ];

  const InventoryBox = ({ config, dataSource, dataKey }) => (
    <Grid size={3}>
      <Paper 
        elevation={0}
        sx={{ 
          p: 1, 
          textAlign: 'start', 
          backgroundColor: config.bgColor,
          border: `2px solid ${config.color}`
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', color: config.color }}>
          {config.label}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 700, mt: 1, color: config.color }}>
          {dataSource?.[dataKey] || 0}
        </Typography>
      </Paper>
    </Grid>
  );

  return (
    <Box sx={{ border: '1px solid #ddd', borderRadius: 2, p: 2 }}>
      <Typography variant="h7" sx={{ fontWeight: 600}}>
        Inventory Quantities
      </Typography>
      
      {/* Cin7 Inventorys */}
      <Box sx={{ mb: 2, mt: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
          Cin7:
        </Typography>
        <Grid container spacing={2}>
          {cin7Config.map((config) => (
            <InventoryBox 
              key={config.key}
              config={config}
              dataSource={cin7Data}
              dataKey={config.key}
            />
          ))}
        </Grid>
      </Box>
      
      {/* Shopify Inventorys */}
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
          Shopify:
        </Typography>
        <Grid container spacing={2}>
          {shopifyConfig.map((config) => (
            <InventoryBox 
              key={config.key}
              config={config}
              dataSource={config.dataSource}
              dataKey={config.key}
            />
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default InventorySection;
